import { render, staticRenderFns } from "./PortfolioManagement.vue?vue&type=template&id=4824046b"
import script from "./PortfolioManagement.vue?vue&type=script&lang=js"
export * from "./PortfolioManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports